import apiClient from "./apiClient";
import { ENDPOINTS } from "@/config/api.enpoints";
import type { GetRequestsParams, RequestResponse } from "@/types/request";

export const getRequests = async (
    params: GetRequestsParams
): Promise<RequestResponse> => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize) queryParams.append("pageSize", params.pageSize.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.sortBy) queryParams.append("sortBy", params.sortBy);
    if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);
    if (params.status) queryParams.append("status", params.status);
    if (params.requestContext) queryParams.append("requestContext", params.requestContext);

    const url = `${ENDPOINTS.ADMIN.request}?${queryParams.toString()}`;
    const response = await apiClient.get<RequestResponse>(url);
    return response.data;
};

export const approveRequest = async (id: string) => {
    const url = ENDPOINTS.ADMIN.approveRequest(id);
    const response = await apiClient.post(url);
    return response.data;
};

export const rejectRequest = async (id: string) => {
    const url = ENDPOINTS.ADMIN.rejectRequest(id);
    const response = await apiClient.post(url);
    return response.data;
};
